document.addEventListener("DOMContentLoaded", () => {
    const swiperContainer = document.querySelector("[data-services-swiper-container]");

    const swiperServices = new Swiper("[data-services-swiper]", {
        slidesPerView: "auto",
        loop: true,
        speed: 10000,
        freeMode: true,
        allowTouchMove: true,
        autoplay: {
            delay: 0,
        }
    });

    function stopAutoPlay () {
        const swiperTranslate = swiperServices.getTranslate();
        swiperServices.setTranslate(swiperTranslate);
        swiperServices.autoplay.stop();
    }

    function startAutoPlay () {
        swiperServices.slideTo(swiperServices.activeIndex, 3000, false);
        swiperServices.autoplay.start();
    }

    swiperContainer.addEventListener("mouseenter", () => stopAutoPlay());
    swiperContainer.addEventListener("mouseleave", () => startAutoPlay());




});
